import apiService from './apiService';

/**
 * Service pour les entités géographiques
 */
class GeoEntityService {
  /**
   * Récupère la liste des entités géographiques avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order, type)
   */
  async getGeoEntities(params = {}) {
    const response = await apiService.get('/geographical-entities', params);
    return response.data;
  }

  /**
   * Récupère une entité géographique spécifique
   * @param {string} id - ID de l'entité géographique
   */
  async getGeoEntity(id) {
    const response = await apiService.get(`/geographical-entities/${id}`);
    return response.data;
  }

  /**
   * Récupère les types d'entités géographiques
   */
  async getGeoTypes() {
    const response = await apiService.get('/geographical-entities/types');
    return response.data;
  }

  /**
   * Récupère les pays avec drapeaux
   */
  async getCountriesWithFlags() {
    return apiService.get('/geographical-entities/with-flags');
  }

  /**
   * Crée une nouvelle entité géographique
   * @param {Object} geoData - Données de l'entité (name, code, type, parent_id)
   */
  async createGeoEntity(geoData) {
    const response = await apiService.post('/geographical-entities', geoData);
    return response.data;
  }

  /**
   * Met à jour une entité géographique
   * @param {string} id - ID de l'entité géographique
   * @param {Object} geoData - Nouvelles données
   */
  async updateGeoEntity(id, geoData) {
    const response = await apiService.put(`/geographical-entities/${id}`, geoData);
    return response.data;
  }

  /**
   * Supprime une entité géographique
   * @param {string} id - ID de l'entité géographique
   */
  async deleteGeoEntity(id) {
    return apiService.delete(`/geographical-entities/${id}`);
  }
}

const geoEntityServiceInstance = new GeoEntityService();
export default geoEntityServiceInstance;
